export const RouteError = () => {
    return (
        <div>
            <h1>Que haces aca, anda palla bobo</h1>
        </div>
    );
};
